/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../Tooltip';

const HelpButton = (props) => {
  const { onClick, className, style, tooltipText, id = 'help-button' } = props;
  const classes = classNames('help-button', className, { hidden: !tooltipText });
  return (
    <span className={classes} onClick={onClick} style={style} data-tip data-for={id}>
      <FontAwesomeIcon icon={faQuestionCircle} className="text-primary" />
      <Tooltip id={id} type="light" place="bottom">
        {tooltipText}
      </Tooltip>
    </span>
  );
};

HelpButton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
};

export default HelpButton;
